import Cookies from 'js-cookie'
import { getQueryString } from "./index";

const TokenKey = 'gywtoken'

export function getToken() {
  return getQueryString('token') || Cookies.get(TokenKey) || null
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, {expires: 3600 * 24 * 30})
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
